import _ from "lodash";

export default class TransitionType {
	static NextEvent = {title: "On the next transition", value: 1};
	static Immediately = {title: "Immediately", value: 0};
	static ChooseEveryTime = {title: "I will choose every time", value: 2};

	static getArray() {
		return _.keys(this).map(k => this[k]);
	}
}